export default __webpack_public_path__ + "static/media/Logo.91e356f5.png";